// extracted by mini-css-extract-plugin
module.exports = {"reviewStar":"ReviewRating_reviewStar__1IGFY"};